/**
 * URLs do ecossistema IBCGP — alinhado ao site institucional e demais projetos.
 */
export default {
  apiCursos: 'https://api.cursos.ibcgp.org.br',
  plataformaGestao: 'https://plataforma.ibcgp.org.br',
  concursosPublico: 'https://concursos.ibcgp.org.br',
  cursosLanding: 'https://nucleodegestaoassomasul.ibcgp.org.br',
  cursosPlataformaLogin:
    'https://nucleodegestaoassomasul.ibcgp.org.br/plataforma/#/login',
  siteInstitucional: 'https://ibcgp.org.br',
  instagram: 'https://www.instagram.com/ibcgp/'
}
